import _ from 'lodash';
import sessionStorageSingleton from '../../../core/configs/sessionStorageSingleton';
import { UserKeyStore } from '../../../core/database/schemas';
import { executeRawSheetsCommands } from '../../utils/commands/execute/executeRawSheetsCommands';
import { SheetManagementSet } from '../../types/sheet/draft';
import { readIDBGroup, readIDBSheet } from './IDBReadManager';
import { v4 as uuid } from 'uuid';

export async function startReadSheetGroup(
  currentSet: SheetManagementSet,
  groupId: string
) {
  const masterFeKey = await sessionStorageSingleton.getFeKey(
    UserKeyStore.MasterFeKey
  );
  const userFeKey = await sessionStorageSingleton.getFeKey(
    UserKeyStore.MasterFeKey
  );

  if (!masterFeKey || !userFeKey)
    throw new Error(`Master OR User Key not found`);

  // TODO: Read from either IDB OR FS
  const { group, rawCommands } = await readIDBGroup(
    masterFeKey,
    groupId,
    userFeKey
  );

  // console.log('group ==== >', group);
  // console.log('rawCommands ==== >', rawCommands);

  // const set = _.cloneDeep(currentSet);
  const set: SheetManagementSet = {
    ...currentSet,
    id: `temporary-${uuid()}`,
    isTemporarySet: true,

    present: {},
    past: {},
    updatedGroups: new Map(),

    deletedGroups: new Set(),
    deletedSheets: new Set(),

    updatedSheets: new Map(),
    updatedSheetViews: new Map(),
    draftedSheets: new Map(),
  };
  // const set: SheetManagementSet = generateSheetsDataSet();
  if (!_.isEmpty(group)) {
    set.updatedGroups.set(group.id, group);
  }

  if (rawCommands) {
    const updatedSet: SheetManagementSet = await executeRawSheetsCommands(
      rawCommands,
      set,
      'group'
    );

    return updatedSet.updatedGroups.get(groupId);
  }

  return group;
}

export async function startReadSheet(
  currentSet: SheetManagementSet,
  sheetId: string
) {
  const masterFeKey = await sessionStorageSingleton.getFeKey(
    UserKeyStore.MasterFeKey
  );
  const sheetFeKey = await sessionStorageSingleton.getFeKey(sheetId);
  if (!masterFeKey || !sheetFeKey) return;

  const { sheet, rawCommands } = await readIDBSheet(
    masterFeKey,
    sheetId,
    sheetFeKey
  );

  console.log('rawCommands', rawCommands);

  // const set = _.cloneDeep(currentSet);
  // Reset changeable Maps - Improve Performance than to simly clone
  const set: SheetManagementSet = {
    ...currentSet,
    id: `temporary-${uuid()}`,
    isTemporarySet: true,

    present: {},
    past: {},
    updatedGroups: new Map(),

    deletedGroups: new Set(),
    deletedSheets: new Set(),

    updatedSheets: new Map(),
    updatedSheetViews: new Map(),
    draftedSheets: new Map(),
  };

  // if (!_.isEmpty(sheet)) {
  // set.temporarySheets.set(sheet.id, sheet);
  // set.updatedSheets.set(sheet.id, sheet);
  // }

  if (rawCommands) {
    await executeRawSheetsCommands(rawCommands, set, 'sheet');

    const updatedSheet = set.updatedSheets.get(sheetId) || {};
    const temporarySheet = set.temporarySheets.get(sheetId) || {};

    return {
      ...temporarySheet,
      ...updatedSheet,
    };
  }

  return sheet;
}
